import React from "react";

function TeamArea() {
  return (
    <section className="team-area-two pt-115 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="section-title text-center mb-60">
              <span className="sub-title">Our Creative Team</span>
              <h2 className="title">Our Professional Team</h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
            <div className="team-item-two">
              <div className="team-thumb-two">
                <a href="/team-details">
                  <img
                    src={require(`../../assets/img/team/h2_team_img01.jpg`)}
                    alt=""
                  />
                </a>
                <div className="team-social-two">
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="team-content-two">
                <h2 className="title">
                  <a href="/team-details">Robert C. Simmons</a>
                </h2>
                <span>Roof Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
            <div className="team-item-two">
              <div className="team-thumb-two">
                <a href="/team-details">
                  <img
                    src={require(`../../assets/img/team/h2_team_img02.jpg`)}
                    alt=""
                  />
                </a>
                <div className="team-social-two">
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="team-content-two">
                <h2 className="title">
                  <a href="/team-details">Christopher Jhon</a>
                </h2>
                <span>Roof Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
            <div className="team-item-two">
              <div className="team-thumb-two">
                <a href="/team-details">
                  <img
                    src={require(`../../assets/img/team/h2_team_img03.jpg`)}
                    alt=""
                  />
                </a>
                <div className="team-social-two">
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="team-content-two">
                <h2 className="title">
                  <a href="/team-details">Karikoka Ahli</a>
                </h2>
                <span>Roof Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
            <div className="team-item-two">
              <div className="team-thumb-two">
                <a href="/team-details">
                  <img
                    src={require(`../../assets/img/team/h2_team_img04.jpg`)}
                    alt=""
                  />
                </a>
                <div className="team-social-two">
                  <ul className="list-wrap">
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="team-content-two">
                <h2 className="title">
                  <a href="/team-details">Dickerson MH</a>
                </h2>
                <span>Roof Engineer</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeamArea;
